import * as yup from "yup"

export const regex = {
  singleName: /^[a-zA-Zא-ת\s'-]*$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  allPhoneNumber: /^(?:\+972|0)(?:5\d|[2-9]|7\d)\d{7}$/,
  IDCompanyId: /^(?:[0-9]{5,9}|51\d{7})$/,
  linkedin: /^https:\/\/www\.linkedin\.com\/in\//,
  email:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  identity: /^\d{9}$/,
  onlyNumbers: /^\d+$/,
  time: /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/,
}

const messagesTranslations = {
  en: {
    fullNameTwo: "Please enter more than 2 letters.",
    firstName:
      "Use only English or Hebrew letters, no symbols. Max 20 characters.",
    phoneNumber: "The phone number entered is incorrect",
    email: "The email address entered is invalid",
    requiredName: "First name and last name must be filled in",
    requiredPhoneNumber: "A phone number must be entered",
    requiredEmail: "An email address must be entered",
    subject: "You must choose subject",
    lastName: "Last name must contain valid characters",
    inquiryDescription: "Inquiry description is required (max 250 characters)",
    termsAgreement: "You must agree to the terms of use",
    confirmReceipt: "You must agree to receive messages from the site",
  },
  he: {
    fullNameTwo: "יש להקליד יותר מ 2- אותיות.",
    firstName: "השתמש באותיות בעברית או באנגלית בלבד, ללא סימנים. עד 20 תווים.",
    phoneNumber: "מספר נייד אינו תקין",
    email: "כתובת האימייל שהוזנה אינה תקינה",
    requiredName: "יש למלא שם פרטי ושם משפחה",
    requiredPhoneNumber: "יש להזין מספר טלפון",
    requiredEmail: "יש להזין כתובת מייל",
    subject: "עליך לבחור נושא",
    lastName: "שם המשפחה חייב להכיל תווים חוקיים",
    inquiryDescription: "תיאור הפנייה נדרש (עד 250 תווים)",
    termsAgreement: "יש להסכים לתנאים של השירות",
    confirmReceipt: "יש לאשר אישור לקבלת מסרים מהאתר",
  },
}

export const messagesInvalid = {
  en: messagesTranslations.en,
  he: messagesTranslations.he,
}

type Language = "en" | "he"

export const commonSchema = {
  common: (language: Language) => {
    const msg = messagesInvalid[language]
    return {
      firstName: yup
        .string()
        .matches(regex.singleName, msg.firstName)
        .max(20, msg.firstName)
        .required(msg.requiredName)
        .min(2, msg.fullNameTwo),
      lastName: yup
        .string()
        .matches(regex.singleName, msg.firstName)
        .max(20, msg.firstName)
        .required(msg.requiredName)
        .min(2, msg.fullNameTwo),
      email: yup
        .string()
        .max(80, msg.email)
        .matches(regex.email, msg.email)
        .required(msg.requiredEmail)
        .min(2, msg.fullNameTwo),
      phone: yup
        .string()
        .matches(regex.onlyNumbers, msg.phoneNumber)
        .max(10, msg.phoneNumber)
        .min(10, msg.phoneNumber)
        .required(msg.requiredPhoneNumber),
      subject: yup.string().max(80, msg.subject).required(msg.subject),
      termsAgreement: yup.boolean().required(msg.termsAgreement),
      confirmReceipt: yup.boolean(),
      inquiryDescription: yup
        .string()
        .max(250, msg.inquiryDescription)
        .required(msg.inquiryDescription),
    }
  },
}
